import type { SpendingBucket, TopMerchant } from '../cards.types';

const dailyAmounts = [
  2300, 500, 1900, 800, 2100, 2200, 5100, 120, 3400, 1400, 1300, 2600, 5000, 900, 2900, 5600, 6000,
  5300, 700, 2000, 1000, 800, 500, 3300, 1500, 5800, 60, 2100, 5900, 3600,
];

export const spendingFixture: SpendingBucket[] = dailyAmounts.map((amount, index) => ({
  day: index + 1,
  amount,
}));

export const SPENDING_TOTAL = 42318.75;
export const SPENDING_CARD_COUNT = 24;

export const topMerchantsFixture: TopMerchant[] = [
  { merchant: { name: 'Spotify', kind: 'logo' }, amount: 8420 },
  { merchant: { name: 'Adobe Creative Cloud', kind: 'logo' }, amount: 2999.4 },
  { merchant: { name: 'Netflix', kind: 'logo' }, amount: 1245 },
];
